define('env',['require','exports','module','environments/local','environments/development','environments/test','environments/preproduction','environments/production','environments/local'],function (require, exports, module) {
  "use strict";

  var envs = {
    "0.0.0.0:8000": require("environments/local"),
    "signup.dev.mdirector.com": require("environments/development"),
    "signup.test.mdirector.com": require("environments/test"),
    "signup.pre.mdirector.com": require("environments/preproduction"),
    "signup.mdirector.com": require("environments/production"),
  };

  var host = window.location.host;
  var env = envs[host];

  if (!env) {
    env = require("environments/local");
  }

  var urlParams = new URLSearchParams(window.location.search);
  env.companyId = urlParams.get("company_id") || null;

  env.setCompanyId = function (companyId) {
    if (companyId) env.companyId = companyId;
  };

  env.getCompanyIdForUrl = function (separator = "?") {
    return env.companyId ? separator + "company_id=" + env.companyId : "";
  };

  return env;
});

